import { render, staticRenderFns } from "./MySubmission.vue?vue&type=template&id=2f1ef78e&scoped=true&"
import script from "./MySubmission.vue?vue&type=script&lang=js&"
export * from "./MySubmission.vue?vue&type=script&lang=js&"
import style0 from "./MySubmission.vue?vue&type=style&index=0&id=2f1ef78e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1ef78e",
  null
  
)

export default component.exports